import styled from "styled-components";
import { backgroundColorPicker } from "../../common/Icon/utils";
import { IconContainerStyleProps } from "./Card.interface";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 120px 1px 1fr;
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: ${({ theme }) => theme.radius}px;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  cursor: pointer;
  .padding {
    padding: ${({ theme }) => theme.spacing * 4}px;
  }
  .divider {
    width: 1px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.gray[400]};
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing * 3}px;
    text-align: center;
    align-items: center;
  }
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing * 3}px;
  > h3 {
    color: ${({ theme }) => theme.colors.gray[900]};
    margin: 0;
    font-size: 16px;
  }
  .address {
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 12px;
  }
  .distance {
    color: ${({ theme }) => theme.colors.gray[400]};
    font-size: 10px;
    font-weight: 700;
  }
`;

export const IconContainer = styled.div<IconContainerStyleProps>`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: ${({ isPremium, isRecommended, isClaimed }) => backgroundColorPicker(isPremium, isRecommended, isClaimed )};
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 25px;
    height: 25px;
    object-fit: contain;
    filter: brightness(0) invert(1);
  }
`;

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing}px;
  .rating {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.gray[800]};
  }
`;
